<ul ngbNav #navarea="ngbNav" class="tab-content-border nav-tabs-bg nav-tabs">
    <li ngbNavItem>
        <a ngbNavLink>Statistiche</a>
        <ng-template ngbNavContent>
            <molla-statistiche-agente [COD_AGE]="COD_AGE"></molla-statistiche-agente>
        </ng-template>
    </li>
    <li ngbNavItem>
        <a ngbNavLink>Ordini</a>
        <ng-template ngbNavContent>
            <molla-order-status-list [COD_AGE]="COD_AGE"></molla-order-status-list>
        </ng-template>
    </li>
    <li ngbNavItem>
        <a ngbNavLink>Clienti</a>
        <ng-template ngbNavContent>
            <molla-customers-list [COD_AGE]="COD_AGE"></molla-customers-list>
        </ng-template>
    </li>
</ul>
<div [ngbNavOutlet]="navarea"></div>   
